import { Icon, IconProps } from "../Icon";

const MinusIcon = (props: IconProps) => (
  <Icon {...props}>
    <path fillRule="evenodd" clipRule="evenodd" d="M7 15H25V17H7V15Z" fill="currentColor" />
  </Icon>
);

export default MinusIcon;
